require('./bootstrap');
require("../prototypes");
// require("../libraries/header-scroll-shadow");
require("../libraries/modals");
require("../libraries/collapseV2.js");

(function() {

	// if (document.documentElement.lang == "gr") {
	// 	(function (d) {var s = d.createElement("script");s.async = true;s.charset="utf-8";s.src = "https://app.blinger.io/uploads/widgets2/1946.js";d.head.appendChild(s);})(window.document);
	// 	// (function (d) {var s = d.createElement("script");s.async = true;s.charset="utf-8";s.src = "https://app.blinger.io/uploads/widgets2/1613.js";d.head.appendChild(s);})(window.document);
	// } else {
	// 	(function (d) {var s = d.createElement("script");s.async = true;s.charset="utf-8";s.src = "https://app.blinger.io/uploads/widgets2/1945.js";d.head.appendChild(s);})(window.document);
	// 	// (function (d) {var s = d.createElement("script");s.async = true;s.charset="utf-8";s.src = "https://app.blinger.io/uploads/widgets2/1617.js";d.head.appendChild(s);})(window.document);
	// }

	const mainLoading = document.getElementById("main-loading");
	const submitBtns = document.getElementsByClassName("js-submit-btn");

	for (let i = 0; i < submitBtns.length; i++) {
		submitBtns[i].addEventListener("click", function() {

			
			mainLoading.classList.remove("hidden");
			
			const arrow = this.getElementsByClassName("js-next-arrow")[0];
			if (arrow) {
				arrow.classList.add("hidden");
			}
			
			const spinner = this.getElementsByClassName("js-next-spinner")[0];
			if (spinner) {
				spinner.classList.remove("hidden");
			}

			setTimeout(() => {
				
				this.disabled = true;
			}, 100);
		});
	}
})();